// @flow
import * as React from 'react';
import type { TFunction } from 'react-i18next';
import { translate } from 'react-i18next';
import styled, { withTheme } from 'styled-components';

import DemographyCard from 'common/modules/printing/components/DemographyCard';
import Radio from 'common/domain/radio';
import DateRange from 'common/domain/DateRange';
import { SCard } from 'common/modules/printing/styles/Card';
import PrintingService from 'common/services/PrintingService';
import PrintingHeader from 'common/modules/printing/components/PrintingHeader';
import PrintingPage from 'common/components/PrintingPage';

import DemographicReach from '../domain/DemographicReach';

const PageWrapper = styled.div`
  padding: 3px;
  background-color: white;
  box-sizing: border-box;

  width: 8.5in;
  height: 11in;
  padding-left: 2.00cm;
  padding-right: 2.00cm;
  font-size: 12px;

  @page {
    margin: 2.00cm 0 2.00cm 0;
  }
`;

const Header = styled.div`
  width: 100%;
  text-align: center;
  margin: ${({ theme }) => theme.metrics.margin}px 0;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  margin-bottom: ${({ theme }) => theme.metrics.margin}px;
`;

const Text = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 16px;
  margin-top: ${({ theme }) => theme.metrics.tinyMargin}px;
  text-align: center;
`;

const Bolder = styled.span`
  font-weight: ${({ theme }) => theme.fonts.weights.bolder};
`;

const TimeParametersCard = styled(SCard)`
  margin: ${({ theme }) => theme.metrics.margin}px 0px;
  padding: ${({ theme }) => theme.metrics.smallMargin}px;
`;

const Capitalized = styled(Text)`
  &:first-letter {
    text-transform: uppercase;
  }
`;

type State = {
  dateRange: DateRange;
  radio?: Radio;
  demographicReach?: DemographicReach;
  loaded: boolean;
}

type Props = {
  t: TFunction;
  theme: any;
}

class DemographyPrintingContainer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loaded: false,
      dateRange: DateRange.default(),
    };
  }

  componentWillMount() {
    const data = PrintingService.getData('DEMOGRAPHY_PRINTING_DATA');
    if (!data) {
      return;
    }

    this.setState({
      dateRange: DateRange.fromISO(data.dateRange),
      demographicReach: data.demographicReach && DemographicReach.parse(data.demographicReach),
      radio: Radio.fromJSON(data.radio),
      loaded: true,
    });

    setTimeout(() => window.print(), 1000);
  }

  render() {
    const { t, theme } = this.props;
    const { loaded, demographicReach, radio, dateRange } = this.state;
    const ageRangeReach = demographicReach ? demographicReach.ageRangeReaches : undefined;
    const genderReach = demographicReach ? demographicReach.genderReach : undefined;

    const dateRangeTranslation = t('date.dateRange', { from: dateRange.from, to: dateRange.to });

    return (
      <PrintingPage loading={!loaded}>
        {radio &&
          <PageWrapper>
            <PrintingHeader radio={radio} />
            <Header>
              <Title style={{ ...theme.fonts.style.secondary, fontWeight: 'bold' }}>{t('demography:demographyPageTitle')
                .toUpperCase()}</Title>
            </Header>
            <TimeParametersCard>
              <Capitalized><Bolder>{dateRangeTranslation}</Bolder></Capitalized>
            </TimeParametersCard>
            <DemographyCard ageGroup={ageRangeReach} genderDemography={genderReach} />
          </PageWrapper>
        }
      </PrintingPage>
    );
  }
}

export default translate('demography')(withTheme(DemographyPrintingContainer));



// WEBPACK FOOTER //
// ./src/statsradio/modules/demography/printing/DemographyPrintingPage.js